import { baseApi } from "../../../shared/api/baseApi"
import { IDropoutRate } from "../model/get/GetDropoutRateInput"

export const DropoutRateApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getDropoutRate: build.query<any, void>({
      query: () => ({
        url: `getDropoutRate`,
        method: "GET",
      }),
      providesTags: ["DropoutRate"],
    }),
    updateDropoutRate: build.mutation<any, any>({
      query: (data) => ({
        url: `updateDropoutRate`,
        method: "PATCH",
        body: { data: data },
      }),
      invalidatesTags: ["DropoutRate"],
    }),
  }),
})

export const { useGetDropoutRateQuery, useUpdateDropoutRateMutation } =
  DropoutRateApi
